import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { tap } from 'rxjs/operators';
import { UserService } from './user.service';

@Injectable({
    providedIn: 'root'
})
export class ConfigurationService {

    private _configuration: any;
    get configuration(): any {
        return this._configuration;
    }

    set configuration(value: any) {
        this._configuration = value;
    }

    constructor(
        private userService: UserService
    ) {
    }

    public downloadConfiguration(): Observable<any> {
        // return this.systemService.configurationQuery()
        //     .pipe(
        //         tap((configuration: AppConfiguration) => {
        //             this.userService.user = configuration.currentUser as UserDetails;
        //             this.configuration = configuration;
        //         })
        //     );
        return of({});
    }
}
